import './symbolIcons.css.js';
import { localize } from '../../../../nls.js';
import { registerColor } from '../../../../platform/theme/common/colorUtils.js';
import { foreground } from '../../../../platform/theme/common/colors/baseColors.js';
import '../../../../platform/theme/common/colors/chartsColors.js';
import '../../../../platform/theme/common/colors/editorColors.js';
import '../../../../platform/theme/common/colors/inputColors.js';
import '../../../../platform/theme/common/colors/listColors.js';
import '../../../../platform/theme/common/colors/menuColors.js';
import '../../../../platform/theme/common/colors/minimapColors.js';
import '../../../../platform/theme/common/colors/miscColors.js';
import '../../../../platform/theme/common/colors/quickpickColors.js';
import '../../../../platform/theme/common/colors/searchColors.js';
registerColor('symbolIcon.arrayForeground', foreground, ( localize(
    9919,
    'The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.booleanForeground', foreground, ( localize(
    9920,
    'The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.classForeground', {
    dark: '#EE9D28',
    light: '#D67E00',
    hcDark: '#EE9D28',
    hcLight: '#D67E00'
}, ( localize(
    9921,
    'The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.colorForeground', foreground, ( localize(
    9922,
    'The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.constantForeground', foreground, ( localize(
    9923,
    'The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.constructorForeground', {
    dark: '#B180D7',
    light: '#652D90',
    hcDark: '#B180D7',
    hcLight: '#652D90'
}, ( localize(
    9924,
    'The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.enumeratorForeground', {
    dark: '#EE9D28',
    light: '#D67E00',
    hcDark: '#EE9D28',
    hcLight: '#D67E00'
}, ( localize(
    9925,
    'The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.enumeratorMemberForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC'
}, ( localize(
    9926,
    'The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.eventForeground', {
    dark: '#EE9D28',
    light: '#D67E00',
    hcDark: '#EE9D28',
    hcLight: '#D67E00'
}, ( localize(
    9927,
    'The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.fieldForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC'
}, ( localize(
    9928,
    'The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.fileForeground', foreground, ( localize(
    9929,
    'The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.folderForeground', foreground, ( localize(
    9930,
    'The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.functionForeground', {
    dark: '#B180D7',
    light: '#652D90',
    hcDark: '#B180D7',
    hcLight: '#652D90'
}, ( localize(
    9931,
    'The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.interfaceForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC'
}, ( localize(
    9932,
    'The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.keyForeground', foreground, ( localize(
    9933,
    'The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.keywordForeground', foreground, ( localize(
    9934,
    'The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.methodForeground', {
    dark: '#B180D7',
    light: '#652D90',
    hcDark: '#B180D7',
    hcLight: '#652D90'
}, ( localize(
    9935,
    'The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.moduleForeground', foreground, ( localize(
    9936,
    'The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.namespaceForeground', foreground, ( localize(
    9937,
    'The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.nullForeground', foreground, ( localize(
    9938,
    'The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.numberForeground', foreground, ( localize(
    9939,
    'The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.objectForeground', foreground, ( localize(
    9940,
    'The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.operatorForeground', foreground, ( localize(
    9941,
    'The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.packageForeground', foreground, ( localize(
    9942,
    'The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.propertyForeground', foreground, ( localize(
    9943,
    'The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.referenceForeground', foreground, ( localize(
    9944,
    'The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.snippetForeground', foreground, ( localize(
    9945,
    'The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.stringForeground', foreground, ( localize(
    9946,
    'The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.structForeground', foreground, ( localize(
    9947,
    'The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.textForeground', foreground, ( localize(
    9948,
    'The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.typeParameterForeground', foreground, ( localize(
    9949,
    'The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.unitForeground', foreground, ( localize(
    9950,
    'The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.variableForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC',
}, ( localize(
    9951,
    'The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
